import ApiClient from '@lib/ApiClient'
import Analytics from '@lib/Analytics'
import Log from '@lib/Log'
import { TIMEOUT_ERROR, waitToReject } from '@lib/util'
import { StoreState } from '@store'

type Props = {
  leadId?: string
  data: Partial<StoreState>
  eventProps?: Record<string, any>
  product?: string
}

export const saveIncomingProspects = async ({
  leadId,
  data,
  eventProps,
  product
}: Props): Promise<string | null> => {
  const fiveSecondsPromise = waitToReject(5000)
  const apiPromise = ApiClient.saveSunfireProspect(data)

  // If not fulfilled in 5 seconds, continue with the default redirection.
  const nextUrl = await Promise.race([apiPromise, fiveSecondsPromise])
    .then(({ url }) => {

      if (!url || url === 'undefined') {
        const msg = 'Sunfire prospect: No URL returned to redirect.'
        Log.info(null, msg)
        throw new Error(msg)
      }

      let hostname = window.location.hostname;
      let queryParams = url.substring(url.indexOf('?') + 1)
      if (product === 'pdp'){
        queryParams += `&pdp=t`
      }

      // use staging if in local environment
      if(hostname.includes('local') || hostname.includes('staging')){
        hostname = 'hiq-staging.healthiq.com'
      }

      url = `${window.location.protocol}//${hostname}/medicare-advantage/shop?${queryParams}`

      Analytics.log('Success', {
        location: 'ma-leadgen',
        service: 'sunfire',
        info: url,
        ...eventProps
      })

      return url
    })
    .catch((error: Error) => {
      const errorMsg = error && error.message === TIMEOUT_ERROR
        ? `Sunfire prospect timeout of 5 seconds reached, redirecting without more delays - leadId: ${leadId}`
        : `Sunfire prospect integration failed for leadID: ${leadId}${error && error.message ? `, with error message ${error.message}.` : '.'}`

      Analytics.log('Error', {
        location: 'ma-leadgen',
        service: 'sunfire',
        info: errorMsg
      })
      throw new Error(errorMsg)
    })

  return nextUrl
}
